export default __webpack_public_path__ + "static/media/iso.602ac3c9.svg";